module.exports = __webpack_public_path__ + "static/img/regardWePic.426c5cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regardWePic.jpg
// module id = fIDK
// module chunks = 0